<ng-container *ngIf="this.navigationList">
    <ng-container *ngFor="let breadcrumb of navigationList; let last = last">
        <div class="page-header mb-3" [ngClass]="this.hideNav === true ? 'mb-3' : ''"
            *ngIf="last && breadcrumb.breadcrumbs !== false">
            <div class="page-block">
                <div class="row align-items-center">
                    <div class="col-md-12">
                        <div class="page-header-title">
                            <ng-container *ngFor="let breadcrumb of navigationList; let last = last">
                                <div class="row">
                                    <div *ngIf="last" class="col-10">
                                            <h5 class="mb-0">
                                                <div *ngIf="addPrevUrl" class="d-inline-block">
                                                    <a  href="javascript:" (click)="redirectToPreviousLocation()" class="badge p-l-0">
                                                        <i class="fas fa-lg fa-arrow-alt-circle-left text-primary"></i>
                                                    </a>
                                                </div>
                                                {{breadcrumb.title}}
                                            </h5>
                                    </div>
                                    <!-- <div *ngIf="breadcrumb.refreshLink" class="col-2 text-right">
                                        <a href="javascript:" (click)="onRefreshClick()">
                                            <i class="feather icon-refresh-ccw text-primary f-16"></i>
                                        </a>
                                    </div> -->
                                </div>
                            </ng-container>
                        </div>
                        <!-- <ul *ngIf="!hideNav && deviceService.isDesktopOrTablet" class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a [routerLink]="routerLinkUrls" *ngIf="type === 'theme2'"><i class="feather icon-home"></i></a>
                                <a [routerLink]="routerLinkUrls" *ngIf="type === 'theme1'">Home</a>
                            </li>
                            <ng-container *ngFor="let breadcrumb of navigationList">
                                <li class="breadcrumb-item" *ngIf="breadcrumb.url !== false"><a [routerLink]="breadcrumb.url">{{breadcrumb.title}}</a></li>
                                <li class="breadcrumb-item" *ngIf="breadcrumb.url === false"><a href="javascript:">{{breadcrumb.title}}</a></li>
                            </ng-container>
                        </ul>
                        <nav *ngIf="!hideNav && deviceService.isMobile"  aria-label="breadcrumb">
                            <ol class="breadcrumb m-0 p-0" style="background-color: transparent;">
                                <li class="breadcrumb-item">
                                    <a [routerLink]="routerLinkUrls" *ngIf="type === 'theme2'"><i class="feather icon-home"></i></a>
                                    <a [routerLink]="routerLinkUrls" *ngIf="type === 'theme1'">Home</a>
                                </li>
                                <ng-container *ngFor="let breadcrumb of navigationList">
                                    <li class="breadcrumb-item" *ngIf="breadcrumb.url !== false"><a [routerLink]="breadcrumb.url">{{breadcrumb.title}}</a></li>
                                    <li class="breadcrumb-item" *ngIf="breadcrumb.url === false"><a href="javascript:">{{breadcrumb.title}}</a></li>
                                </ng-container>
                            </ol>
                        </nav> -->
                        <div *ngIf="breadcrumb.refreshLink" class="row border-top pt-1 mt-2">
                            <div class="col-10">
                                <small class="form-text text-muted">
                                    Last updated: {{refreshTime}}
                                </small>
                            </div>
                            <div class="col-2 text-right align-center pt-1">
                                <a href="javascript:" (click)="onRefreshClick()">
                                    <i class="feather icon-refresh-ccw text-primary f-16"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
